export default __webpack_public_path__ + "static/trackrecordimg_1-35a2607566bbe362a0960b15d28b433c.png";